/**
 * Coups de pouce — Attendu 612 « Sens de la multiplication de deux décimaux ».
 * Une entrée par generator_key (cf. gen_612.js).
 */

// ── Compter les décimales, placer la virgule : animation (id cp612play1) ──
// On sait que 37 × 29 = 1073 ; pour 3,7 × 2,9 on compte 1 + 1 = 2 décimales,
// puis la virgule se place dans 1073 → 10,73.
const SVG_SENSMULT_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 252" role="img"
     aria-label="On sait que 37 fois 29 égale 1073. Pour 3,7 fois 2,9 : le 7 et le 9 sont entourés, chaque facteur a une décimale, soit deux décimales en tout. La virgule se place à deux rangs à partir de la droite : le résultat est 10,73, et les chiffres 7 et 3 sont les deux décimales">
  <g id="cp612play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- le fait connu -->
  <text x="20" y="56" font-size="14" font-weight="700" fill="#64748b" font-family="system-ui,sans-serif" opacity="0">On sait que 37 × 29 = 1073<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+0.3s" fill="freeze"/></text>
  <!-- le produit décimal -->
  <!-- facteurs à parties détachées (écart entier/décimale élargi pour les cercles) -->
  <g font-size="18" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" text-anchor="middle" opacity="0">
    <text x="66" y="102">3</text>
    <text x="76" y="102">,</text>
    <text x="90" y="102">7</text>
    <text x="118" y="102" fill="#64748b">×</text>
    <text x="140" y="102">2</text>
    <text x="150" y="102">,</text>
    <text x="164" y="102">9</text>
    <text x="192" y="102" fill="#64748b">=</text>
    <text x="230" y="102" fill="#94a3b8">?</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+0.3s" fill="freeze"/>
  </g>
  <!-- cercles de comptage des décimales -->
  <g opacity="0">
    <circle cx="90" cy="96" r="12" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="80" y="138" font-size="11" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">1 décimale</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+1.6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <circle cx="164" cy="96" r="12" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="158" y="138" font-size="11" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">1 décimale</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+2.4s" fill="freeze"/>
  </g>
  <text x="204" y="138" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif" opacity="0">→ 2 décimales en tout<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+3.4s" fill="freeze"/></text>
  <!-- le « ? » de départ reste tel quel (choix prof 2026-08-23) -->
  <g opacity="0">
    <text x="202" y="166" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="end" font-family="system-ui,sans-serif">résultat : 10</text>
    <text x="211" y="166" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">,</text>
    <text x="222" y="166" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif">73</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+4.8s" fill="freeze"/>
  </g>
  <g opacity="0">
    <ellipse cx="232" cy="161" rx="15" ry="12" fill="none" stroke="#B45309" stroke-width="1.8"/>
    <text x="232" y="186" font-size="11" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">les 2 décimales</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+5.6s" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="198" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="206" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Compte les décimales des deux facteurs.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="220" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="228" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Place la virgule d'autant de rangs</text>
    <text x="36" y="244" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">à partir de la droite.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play1.click+6.6s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_SENSMULT_612 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_SENSMULT_ANIM,
        },
    ],
};


// ── Le modèle qui survit : répétition ✓ / répétition ✗ / rectangle (id cp612play3) ──
// Trois temps (demande prof 2026-08-28) : 3 × 2,9 se répète, 3,7 × 2,9 ne se
// répète pas, le rectangle quadrillé donne un sens au produit dans tous les
// cas. Le résultat chiffré n'est jamais affiché.
const SVG_MODELE_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 352" role="img"
     aria-label="Répétition d'un facteur. À gauche : pour 3 fois 2,9, trois barres de longueur 2,9 s'empilent, on répète 3 fois, ça marche. À droite : pour 3,7 fois 2,9, après trois barres il reste un morceau de barre avec un point d'interrogation, répéter 3,7 fois est impossible. En dessous : un rectangle de côtés 3,7 et 2,9 avec un quadrillage d'unités montre que l'aire existe et vaut 3,7 fois 2,9. La répétition ne marche que si un facteur est entier ; le rectangle donne un sens au produit dans tous les cas">
  <g id="cp612play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- SCÈNE 1 : la répétition fonctionne -->
  <text x="20" y="34" font-size="12" font-weight="700" fill="#64748b" font-family="system-ui,sans-serif" opacity="0">Répétition d'un facteur<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.03;0.06;1" dur="13s" begin="cp612play3.click" fill="freeze"/></text>
  <text x="20" y="52" font-size="14" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" opacity="0">3 × 2,9<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.03;0.06;1" dur="13s" begin="cp612play3.click" fill="freeze"/></text>
  <g opacity="0">
    <rect x="20" y="60" width="74" height="12" rx="2" fill="#1D9E75" fill-opacity="0.18" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="57" y="70" font-size="10" font-weight="600" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2,9</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.04;0.07;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="76" width="74" height="12" rx="2" fill="#1D9E75" fill-opacity="0.18" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="57" y="86" font-size="10" font-weight="600" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2,9</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.08;0.11;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="92" width="74" height="12" rx="2" fill="#1D9E75" fill-opacity="0.18" stroke="#1D9E75" stroke-width="1.5"/>
    <text x="57" y="102" font-size="10" font-weight="600" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2,9</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.12;0.15;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <text x="57" y="134" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">on répète 3 fois ✓<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.18;0.22;1" dur="13s" begin="cp612play3.click" fill="freeze"/></text>
  <!-- SCÈNE 2 : la répétition s'effondre -->
  <text x="190" y="52" font-size="14" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" opacity="0">3,7 × 2,9<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.26;0.29;1" dur="13s" begin="cp612play3.click" fill="freeze"/></text>
  <g opacity="0">
    <rect x="190" y="60" width="74" height="12" rx="2" fill="#64748b" fill-opacity="0.15" stroke="#64748b" stroke-width="1.5"/>
    <rect x="190" y="76" width="74" height="12" rx="2" fill="#64748b" fill-opacity="0.15" stroke="#64748b" stroke-width="1.5"/>
    <rect x="190" y="92" width="74" height="12" rx="2" fill="#64748b" fill-opacity="0.15" stroke="#64748b" stroke-width="1.5"/>
    <text x="227" y="70" font-size="10" font-weight="600" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2,9</text>
    <text x="227" y="86" font-size="10" font-weight="600" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2,9</text>
    <text x="227" y="102" font-size="10" font-weight="600" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">2,9</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.30;0.34;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="190" y="108" width="52" height="12" rx="2" fill="none" stroke="#B45309" stroke-width="1.5" stroke-dasharray="4 3"/>
    <text x="250" y="118" font-size="12" font-weight="700" fill="#B45309" font-family="system-ui,sans-serif">?</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.38;0.42;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="227" y="134" font-size="12" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">répéter 3,7 fois ?</text>
    <text x="283" y="134" font-size="14" font-weight="700" fill="#dc2626" font-family="system-ui,sans-serif">✗</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.45;0.49;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <!-- SCÈNE 3 : le rectangle prend le relais -->
  <text x="20" y="162" font-size="13" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" opacity="0">Le rectangle, lui, fonctionne toujours :<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.54;0.58;1" dur="13s" begin="cp612play3.click" fill="freeze"/></text>
  <g opacity="0">
    <rect x="104" y="186" width="126" height="99" fill="#FEF3C7" stroke="#0f172a" stroke-width="1.8"/>
    <text x="167" y="182" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">3,7</text>
    <text x="96" y="239" font-size="13" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">2,9</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.60;0.65;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="206" y="186" width="24" height="99" fill="#FDE68A" stroke="none"/>
    <rect x="104" y="254" width="102" height="31" fill="#FDE68A" stroke="none"/>
    <line x1="138" y1="186" x2="138" y2="285" stroke="#94a3b8" stroke-width="1"/>
    <line x1="172" y1="186" x2="172" y2="285" stroke="#94a3b8" stroke-width="1"/>
    <line x1="206" y1="186" x2="206" y2="285" stroke="#94a3b8" stroke-width="1"/>
    <line x1="104" y1="220" x2="230" y2="220" stroke="#94a3b8" stroke-width="1"/>
    <line x1="104" y1="254" x2="230" y2="254" stroke="#94a3b8" stroke-width="1"/>
    <rect x="104" y="186" width="126" height="99" fill="none" stroke="#0f172a" stroke-width="1.8"/>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.68;0.73;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <text x="167" y="303" font-size="13" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">l'aire existe : c'est 3,7 × 2,9<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.76;0.80;1" dur="13s" begin="cp612play3.click" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="316" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="324" font-size="12" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">La répétition ne marche que si un facteur est entier.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.85;0.89;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="334" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="342" font-size="12" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Le rectangle donne un sens au produit dans tous les cas.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.91;0.95;1" dur="13s" begin="cp612play3.click" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_MODELE_612 = {
    pages: [
        {
            titre: 'Changer de modèle',
            svg: SVG_MODELE_ANIM,
        },
    ],
};

// ── Aire du rectangle : rappel de formule (id cp612play2) ──
// 12,3 × 6,2 = 76,26 cm² — dimensions HORS plage du tirage (le générateur
// reste sous 9,5 × 5,0), donc jamais recopiable.
const SVG_AIRE_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 260" role="img"
     aria-label="Un rectangle de longueur 12,3 centimètres et de largeur 6,2 centimètres. La formule : aire du rectangle égale longueur fois largeur. On remplace : aire égale 12,3 fois 6,2, soit 76,26 centimètres carrés. L'aire s'exprime en unité carrée : ici des centimètres carrés, ailleurs des mètres carrés ou des millimètres carrés">
  <g id="cp612play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- le rectangle et ses dimensions -->
  <g opacity="0">
    <rect x="60" y="58" width="148" height="74" fill="#FEF3C7" stroke="#0f172a" stroke-width="1.8"/>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.4s" begin="cp612play2.click+0.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="134" y="50" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">12,3 cm</text>
    <text x="216" y="99" font-size="13" font-weight="700" fill="#0f172a" text-anchor="start" font-family="system-ui,sans-serif">6,2 cm</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play2.click+1.2s" fill="freeze"/>
  </g>
  <!-- la formule -->
  <text x="40" y="156" font-size="14" font-weight="700" fill="#B45309" text-anchor="start" font-family="system-ui,sans-serif" opacity="0">Aire du rectangle = Longueur × largeur<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play2.click+2.4s" fill="freeze"/></text>
  <!-- la substitution puis le résultat -->
  <text x="40" y="180" font-size="14" font-weight="700" fill="#0f172a" text-anchor="start" font-family="system-ui,sans-serif" opacity="0">Aire = 12,3 × 6,2<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play2.click+3.8s" fill="freeze"/></text>
  <text x="178" y="180" font-size="14" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif" opacity="0">= 76,26 cm²<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play2.click+5s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="200" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="208" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Aire du rectangle = Longueur × largeur.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play2.click+6.2s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="222" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="230" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">N'oublie pas l'unité d'aire :</text>
    <text x="36" y="246" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">ici cm² (ailleurs m², mm², …).</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp612play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp612play2.click+6.8s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_AIRE_612 = {
    pages: [
        // Page 1 (revue 2026-08-28) : le sens — pourquoi une multiplication.
        {
            titre: 'Changer de modèle',
            svg: SVG_MODELE_ANIM,
        },
        // Page 2 : la formule et son application.
        {
            titre: "La formule de l'aire",
            svg: SVG_AIRE_ANIM,
        },
    ],
};


// ── Le rectangle qui rétrécit : deux présentations côte à côte (id cp612play4) ──
// Gauche : 45 × 20 = 900. Droite : le côté 45 devient 4,5 (÷ 10), il reste une
// tranche, l'aire devient 90 (÷ 10). Présentation en parallèle (demande prof
// 2026-08-28) pour comparer les deux états. Le générateur exclut les multiples
// de 10 (B ∈ [12;29] exclut 20) : 45 × 20 n'est jamais tirable en exercice.
const SVG_EFFET_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 252" role="img"
     aria-label="À gauche : un rectangle de côtés 45 et 20, découpé en 10 tranches, d'aire 45 fois 20 égale 900. À droite : le même rectangle où le côté 45 est devenu 4,5, divisé par 10 ; il ne reste qu'une tranche, le reste est en pointillés. Son aire vaut 4,5 fois 20 égale 90. Une flèche fois 0,1, c'est-à-dire divisé par 10, relie les côtés 45 et 4,5 ; une autre relie les aires 900 et 90 : un facteur multiplié par 0,1, le produit est multiplié par 0,1">
  <g id="cp612play4" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- PANNEAU GAUCHE : 45 × 20 = 900 -->
  <g opacity="0">
    <rect x="28" y="78" width="136" height="68" fill="#FEF3C7" stroke="#0f172a" stroke-width="1.8"/>
    <text x="96" y="70" font-size="14" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">45</text>
    <text x="22" y="116" font-size="14" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">20</text>
    <text x="96" y="170" font-size="14" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">45 × 20 = 900</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.04;0.10;1" dur="10s" begin="cp612play4.click" fill="freeze"/>
  </g>
  <!-- les 10 tranches du panneau gauche -->
  <g opacity="0">
    <line x1="41.6" y1="78" x2="41.6" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="55.2" y1="78" x2="55.2" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="68.8" y1="78" x2="68.8" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="82.4" y1="78" x2="82.4" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="96.0" y1="78" x2="96.0" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="109.6" y1="78" x2="109.6" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="123.2" y1="78" x2="123.2" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="136.8" y1="78" x2="136.8" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <line x1="150.4" y1="78" x2="150.4" y2="146" stroke="#94a3b8" stroke-width="0.8"/>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.18;0.24;1" dur="10s" begin="cp612play4.click" fill="freeze"/>
  </g>
  <!-- PANNEAU DROIT : le côté ÷ 10, la tranche restante -->
  <g opacity="0">
    <rect x="210" y="78" width="136" height="68" fill="none" stroke="#94a3b8" stroke-width="1.2" stroke-dasharray="5 4"/>
    <rect x="210" y="78" width="13.6" height="68" fill="#FDE68A" stroke="#B45309" stroke-width="1.8"/>
    <text x="217" y="70" font-size="14" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">4,5</text>
    <text x="204" y="116" font-size="14" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">20</text>
    <path d="M112,58 Q160,40 206,58" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <path d="M206,58 L198,52 M206,58 L198,60" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <text x="160" y="40" font-size="12" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">× 0,1 (÷ 10)</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.32;0.42;1" dur="10s" begin="cp612play4.click" fill="freeze"/>
  </g>
  <!-- l'aire suit -->
  <g opacity="0">
    <text x="278" y="170" font-size="14" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">4,5 × 20 = 90</text>
    <path d="M135,180 Q226,202 317,180" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <path d="M317,180 L308,182 M317,180 L311,187" fill="none" stroke="#B45309" stroke-width="1.6"/>
    <text x="226" y="206" font-size="12" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">× 0,1 (÷ 10)</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.52;0.60;1" dur="10s" begin="cp612play4.click" fill="freeze"/>
  </g>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="216" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="224" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Un facteur divisé par 10 → le produit est divisé par 10.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.70;0.76;1" dur="10s" begin="cp612play4.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="234" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="242" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Le produit suit toujours son facteur.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.82;0.88;1" dur="10s" begin="cp612play4.click" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_EFFET_612 = {
    pages: [
        {
            titre: 'Un exemple',
            svg: SVG_EFFET_ANIM,
        },
    ],
};

const CP_612 = {
    // Formats « sens » (revue 2026-08-28)
    sens_effet_qcm_unique: CP_EFFET_612,
    sens_modele_tableau_vf: CP_MODELE_612,
    sens_modele_texte_trou_saisie: CP_MODELE_612,
    sensmult_qcm_unique: CP_SENSMULT_612,
    // Aire : animation dédiée « rappel de formule » (revue 2026-08-23)
    aire_rectangle_texte: CP_AIRE_612,
    sensmult_relier: CP_SENSMULT_612,
    sensmult_tableau_vf: CP_SENSMULT_612,
    sensmult_texte_trou_drag: CP_SENSMULT_612,
};

export default CP_612;
